import { render, staticRenderFns } from "./invitefriends.vue?vue&type=template&id=58dabb2a&scoped=true&"
import script from "./invitefriends.vue?vue&type=script&lang=js&"
export * from "./invitefriends.vue?vue&type=script&lang=js&"
import style0 from "./invitefriends.vue?vue&type=style&index=0&id=58dabb2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dabb2a",
  null
  
)

export default component.exports